"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var purchaseNormalizer = function (response) {
    var data = response.data || {
        order_number: '',
        referral_link: '',
        security_code: '',
        referral: '',
    };
    return __assign(__assign({}, response), { data: {
            orderNumber: data.order_number,
            referral: data.referral,
            referralLink: data.referral_link,
            securityCode: data.security_code,
        } });
};
exports.default = purchaseNormalizer;
